/**
 * Responsive sizing utility functions
 * These functions convert pixel values to viewport-relative units (vw/vh)
 */

// Base dimensions for calculations
const BASE_WIDTH = 1440; // Base design width in pixels
const BASE_HEIGHT = 812; // Base design height in pixels

/**
 * Converts a pixel value to viewport width percentage (vw)
 * @param {number} px - The pixel value to convert
 * @returns {string} - The converted value as a vw CSS unit
 */
export const vw = (px) => {
  return `${(px / BASE_WIDTH) * 100}vw`;
};

/**
 * Converts a pixel value to viewport height percentage (vh)
 * @param {number} px - The pixel value to convert
 * @returns {string} - The converted value as a vh CSS unit
 */
export const vh = (px) => {
  return `${(px / BASE_HEIGHT) * 100}vh`;
};

// Example usage:
// import { vw, vh } from 'path/to/resizeFunction';
//
// const styles = {
//   container: {
//     width: vw(320),
//     height: vh(200),
//     padding: `${vh(10)} ${vw(15)}`
//   }
// };
